// We spect something like [{id:'...', ...fields}, ...restOfArray]
export const getIdsFromArray = (list = []) => {
  return list.length
    ? list.reduce((acc, i) => {
        acc.push(i.id ? i.id : i)
        return acc
      }, [])
    : []
}

export function secondsToHms(d) {
  d = Number(d)
  const h = Math.floor(d / 3600)
  const m = Math.floor((d % 3600) / 60)
  const s = Math.floor((d % 3600) % 60)

  const hDisplay = ('0' + h).slice(-2) + ':'
  const mDisplay = ('0' + m).slice(-2) + ':'
  const sDisplay = ('0' + s).slice(-2)
  return hDisplay + mDisplay + sDisplay
}

export function HmsToSeconds(hms) {
  const [h, m, s] = hms.split(':')
  const seconds =
    (Number(h) || 0) * 3600 + (Number(m) || 0) * 60 + (Number(s) || 0)

  return seconds
}

// This is done in a linear time O(n) without recursion
// memory complexity is O(1) or O(n) if mutable param is set to false
export function flatten(array, mutable) {
  const toString = Object.prototype.toString
  const arrayTypeStr = '[object Array]'

  const result = []
  const nodes = (mutable && array) || array.slice()
  let node

  if (!array.length) {
    return result
  }

  node = nodes.pop()

  do {
    if (toString.call(node) === arrayTypeStr) {
      nodes.push.apply(nodes, node)
    } else {
      result.push(node)
    }
  } while (nodes.length && (node = nodes.pop()) !== undefined)

  result.reverse() // we reverse result to restore the original order
  return result
}

export function shortenUUIDs(ids) {
  if (!Array.isArray(ids)) return ids
  let shortenIds = ids.map((id) => id.split('-')[0])
  return shortenIds
}

export function renameKey(oldProp, newProp, { [oldProp]: old, ...others }) {
  return {
    [newProp]: old,
    ...others,
  }
}

export function capitalize(value) {
  if (!value) return ''
  return value.charAt(0).toUpperCase() + value.slice(1)
}

export function stringToColour(str) {
  let hash = 0
  for (let i = 0; i < str.length; i++) {
    hash = str.charCodeAt(i) + ((hash << 5) - hash)
  }
  let colour = '#'
  for (let i = 0; i < 3; i++) {
    let value = (hash >> (i * 8)) & 0xff
    colour += ('00' + value.toString(16)).substr(-2)
  }
  return colour
}

export function pastelColors() {
  const r = (Math.round(Math.random() * 100) + 100).toString(16)
  const g = (Math.round(Math.random() * 100) + 100).toString(16)
  const b = (Math.round(Math.random() * 100) + 100).toString(16)
  return '#' + r + g + b
}

export function calculateAverage(list, valueKey = 'value') {
  const { sum, count } = list.reduce(
    (acc, item) => {
      const numericValue = parseFloat(item[valueKey])
      if (!isNaN(numericValue)) {
        acc.sum += numericValue
        acc.count++
      }
      return acc
    },
    { sum: 0, count: 0 }
  )

  const average = count > 0 ? sum / count : 0
  return average
}

export function getYearsUpTo(year) {
  const current = new Date().getFullYear()
  const years = []
  for (year; year <= current; year++) {
    years.unshift(year.toString())
  }
  return years
}
